import { SxProps } from '@mui/material';
import { black, blue, blue3, grey13Opacity38, grey4, grey9, white, yellow } from 'app/components/ThemeProvider/colors';

export const tabs: SxProps = {
  width: '100%',
  height: '70px',
  borderRadius: '8px',
  boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
  mb: '32px',
  p: '0 20px',

  '& .MuiTabs-scroller': {
    display: 'flex',
    height: '100%',
    justifyContent: 'space-between',
    gap: '12px',
  },

  '& .MuiTabs-indicator': {
    height: '3px',
    backgroundColor: 'rgba(255, 199, 44, 1)',
  },

  '& .MuiTabs-flexContainer': {
    gap: '22px',
  },
};

export const tab: SxProps = {
  fontFamily: 'Yelo',
  fontWeight: '400',
  fontSize: '16px',
  width: 'auto',
  padding: '12px',

  '&.Mui-selected': {
    fontFamily: 'Yelo',
    fontWeight: '600',
    fontSize: '17px',
    color: black,
  },
};

export const accordionBox: SxProps = {
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
};

export const signBox: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
};

export const sign: SxProps = {
  backgroundColor: blue,
  color: white,

  '&.Mui-disabled': {
    backgroundColor: grey9,
    color: grey13Opacity38,
  },

  '&:hover': {
    backgroundColor: blue3,
  },

  '@media screen and (max-width: 430px)': {
    fontSize: '14px !important',
  },
};

export const customIconBtn = (disabled: boolean, direction: string) => {
  return {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: grey4,
    display: disabled ? 'none' : 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: direction === 'right' && '-16px',
    left: direction === 'left' && '-16px',
    transform: direction === 'left' && 'rotate(180deg)',
    top: '88px',
    zIndex: 1,

    '&:hover': {
      cursor: 'pointer',
      background: yellow,
    },
  };
};
